import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList } from "@/mixins/index";
import addbeforeLogin from "./components/addbeforeLogin"; // announcement

export default {
  name: "beforeLogin",
  mixins: [loadMoreList],
  components: {
    addbeforeLogin: addbeforeLogin
  },
  data: function data() {
    return {
      pagingReqFn: "loginBeforeAnnounceData",
      pagingReqValue: "data",
      paramsData: {
        id: '',
        content: '',
        author: '',
        top: '',
        state: '0'
      },
      announceTypeList: [],
      drawer: false,
      content: '',
      delIds: [],
      date: [],
      state: [{
        label: '全部',
        value: '0'
      }, {
        label: '启用',
        value: 1
      }, {
        label: '禁用',
        value: 2
      }]
    };
  },
  activated: function activated() {
    var _this = this;

    this.getList();
    this.$api.announceTypeList({
      id: 1
    }).then(function (res) {
      if (res.code == 0) {
        _this.announceTypeList = res.data;
      }
    });
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    datechange: function datechange(e) {},
    viewOpen: function viewOpen(content) {
      this.content = this.$utils.textRepl(content);
      this.drawer = true;
    },
    del: function del(dateList) {
      var _this2 = this;

      var ids = dateList.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'loginBeforeAnnounceDel',
        data: {
          id: ids.toString()
        }
      }).then(function () {
        _this2.getList();
      });
    }
  }
};